<template>
  <div class="about">
    <Header :type="pageType" />
    <div class="banner"></div>
    <div class="content clearfix">
      <ul class="tabs">
        <li
          v-for="tab in tabs"
          :key="tab.id"
          :class="['tab', current == tab.id ? 'active' : '']"
          @click="onChange(tab.id)"
        >
          <i class="disc"></i>{{ tab.name }}
        </li>
      </ul>
      <div class="main_content">
        <template v-if="current === 51">
          <CompanyQualification />
        </template>
        <template v-if="current === 52">
          <OperatedPlatform />
        </template>
        <template v-if="current === 53">
          <Empty />
        </template>
        <template v-if="current === 54">
          <div class="table_div">
            <table class="table_class">
              <thead>
                <tr>
                  <th style="width:200px;">机构名称</th>
                  <th style="width:210px;">合作时间</th>
                  <!-- <th style="width:210px;">合作范围</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in cooperList" :key="index">
                  <td class="power">
                    {{ item.title }}
                  </td>
                  <td>{{ item.startTime }} ~ {{ item.endTime }}</td>
                  <!-- <td>{{ item.cooperationScope || '' }}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <pagaing
            :total="total1"
            :pageSize="pageSize"
            :pageIndex="pageIndex"
            @change="onPageChange1"
          />
        </template>
        <template v-if="current === 55">
          <PolicyInspection />
        </template>
        <template v-if="current === 65">
          <Empty />
        </template>
        <template v-if="current === 57">
          <Branch />
        </template>
        <template v-if="current === 58">
          <Contact />
        </template>
        <template v-if="current === 59">
          <Report />
        </template>
        <template v-if="current === 31">
          <div class="table_div">
            <table class="table_class">
              <thead>
                <tr>
                  <th style="width:200px;">产品名称</th>
                  <th style="width:210px;">备案名称</th>
                  <th style="width:210px;">备案编号</th>
                  <th style="width:120px;">险种类别</th>
                  <th style="width:210px;">承保公司</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tableData" :key="index">
                  <td class="power">
                    {{ item.productName }}
                  </td>
                  <td>{{ item.ruleName }}</td>
                  <td>{{ item.indicateNo }}</td>
                  <td>{{ item.type }}</td>
                  <td>{{ item.companyName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagaing
            :total="total"
            :pageSize="pageSize"
            :pageIndex="pageIndex"
            @change="onPageChange"
          />
        </template>
        <template v-if="current === 32">
          <!-- <div class="description">
						<div class="title">骆驼规划服务协议</div>
						<p>
							感谢您选择“骆驼规划”网络服务平台（以下简称“平台”。骆驼规划服务使用协议（以下简称“本协议”）是润安国际保险经纪有限公司（以下简称“骆驼规划”和“我们”）和您签订。
						</p>
						<div class="title_level1">
							<div class="icon"></div>
							一、骆驼规划服务协议的确认
						</div>
						<p>1、请您仔细阅读协议内容，特别是字体加粗部分。</p>
						<p>
							2、如果您对本协议内容存在疑虑或异议，勿进行下一步操作。您可以通过“骆驼规划”微信公众号进行咨询，以便我们为您解释和说明。
						</p>
						<p>
							3、您通过页面点击或其他方式确认即表示您已同意本协议。
						</p>
						<div class="title_level1">
							<div class="icon"></div>
							二、骆驼规划服务相关定义
						</div>
						<p>
							1、保险服务：指我们提供的基于用户问卷信息和意向进行相关的问题回答，保险信息交流以及保险有关的辅助信息咨询服务。
						</p>
						<p>
							2、保险问卷：指您在保险咨询服务中自愿填写的包含个人信息的问卷。
						</p>
						<p>
							3、保险机构：指经中国保险监督管理机构（保监会）批准设立，并依法进行工商登记注册，向您提供保险产品及相关服务的商业保险公司及保险经纪公司。
						</p>
						<p>
							4、投保：指您借助平台技术支持直接向保险机构购买产品的行为。
						</p>
						<p>
							5、承保：指保险机构在您提出投保请求后，经审核同意与您签订保险合同，承诺履行保险合同中约定保险责任的行为。
						</p>
						<div class="title_level1">
							<div class="icon"></div>
							三、声明与承诺
						</div>
						<p class="title_level2">1、 使用者资格</p>
						<p>
							您应是具有法律规定的完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人、法人或其他组织。<b
								>若您不具备前述主体资格，您应当立即停止使用平台的服务，由此导致的一切后果由您及您的监护人承担。</b
							>
						</p>
						<p>
							您可以使用骆驼规划认可的第三方账户直接登录骆驼规划平台，但在接受或购买骆驼规划产品或服务时，您可能需要提供法律法规要求的必要身份信息及资料。
						</p>
						<p class="title_level2">2、 用户信息</p>
						<p>
							在完成注册、激活或验证流程时，您应当按照相应页面的提示提供您的身份信息及资料，以使之真实、及时、完整和准确；
						</p>
						<p>
							当您的身份信息及资料发生变化时，您应当及时更新并准确提供您的身份信息及资料。
						</p>
						<p class="title_level2">3、 账户安全</p>
						<p>
							<b
								>使用手机号或微信登录等身份要素进行的操作、发出的指令是为您本人做出。请您妥善保管登录的认证要素，不要将其提供给任何第三方使用，由此产生的风险和损失将由您个人全部承担。</b
							>
						</p>
						<p>
							<b>
								如发现任何人未经授权使用您的平台登录名和密码，您应当立即通知平台，授权骆驼规划经过必要身份识别措施后更改密码或作出其他应对措施。但骆驼规划不会对因您未能遵守本款规定而发生的任何损失负责。</b
							>
						</p>
						<p class="title_level2">4、 账户管理</p>
						<p>
							<b
								>用户标识和账户仅限您本人使用，请勿转让、借用、赠与、继承。</b
							>
						</p>
						<p class="title_level2">5、 您承诺遵守以下约定：</p>
						<p>
							1）您承诺不为任何非法目的或以任何非法方式使用平台服务，并承诺遵守中国相关法律、法规及互联网之使用惯例。<b
								>如我们发现或经第三方举报并经核实您存在前述行为或情形，我们可能会对您暂停或终止全部或部分平台服务，并视需要报告监管部门，并可能依法移送司法机关</b
							>
						</p>
						<p>
							2）在未经骆驼规划事先书面同意的情况下，不以复制、传播等任何方式使用平台上展示的资料、信息或数据。
						</p>
						<p>
							3）您不得对我们的系统和程序采取反向工程手段进行破解，不得对上述系统和程序（包括但不限于源程序、目标程序、技术文档、客户端至服务端端数据、服务器数据）进行复制、修改、编译、整合和篡改，不得修改或增减我们系统的功能。
						</p>
						<p class="title_level2">6、 您理解并同意：</p>
						<p>
							1）我们的服务有赖于系统的准确运行及操作。若出现系统差错、故障、您或我们不当获利等情形、您同意我们可以采取更正差错、扣减积分、取消服务资格等适当纠正措施。
						</p>
						<p>
							2）保险合同的缔结和履行甶您和保险机构共同合意完成。我们建议您，在保险合同缔约前审慎选择保险机构和保险产品，在保险合同履行过程中关注和督促保险机构完整履行保险合同的各项义务。
						</p>
						<p>
							3）我们因市场变化或业务调整等原因可能会变更、暂停、终止与保险机构的合作，您可能无法通过平台接受保险机构的服务或购买产品。您可以线下与保险机构联系接受服务或购买产品。
						</p>
						<p>
							4）因通过您提供的电子邮件地址、手机或微信等联系方式无法及时与您取得联系，导致您在使用平台服务过程中产生任何损失或增加费用的，甶您自行承担。平台有权以各种方式（包括但不限于电子邮件、手机短信等）发送与平台提供服务相关的各类商业信息，如您拒绝继续接收上述商业信息，必须通过书面方式通知平台。
						</p>
						<p class="title_level2">
							7、 您使用本平台过程中的禁止行为包括但不限于：
						</p>
						<p>
							1）侵害他人名誉权、隐私权、商业秘密、商标权、著作权、专利权等合法权益；
						</p>
						<p>
							2）违反保密义务；
						</p>
						<p>
							3）冒用他人名义使用我们的服务；
						</p>
						<p>
							4）从事可能侵害我们的服务系统、数据的行为；
						</p>
						<p>
							5）不得上载、张贴或发送任何非法、有害、诽谤、猥亵、侵害他人隐私权、散布种族歧视或伤风败俗的信息资料；
						</p>
						<p>
							6）不得上载、张贴或发送任何教唆他人构成犯罪行为的信息资料。
						</p>
						<div class="title_level1">
							<div class="icon"></div>
							四、骆驼规划平台服务
						</div>
						<p class="title_level2">
							我们提供的平台服务包括如下内容：
						</p>
						<p>
							1、私人保险咨询服务。为满足用户的个性化需求，我们会针对合作的保险机构提供的产品，甶专业保险机构人员为用户进行一对一专属定制保险服务方案。
						</p>
						<p>
							2、理赔、纠纷协助。发生保险事故后，我们可以全程协助您向保险公司进行理赔并为您处理解纷提供法律和医疗方面的协助。
						</p>
						<p>
							3、产品购买。您可以通过平台获知各保险机构对于保险产品的种类、内容和报价等，并通过点开相应链接直接向相应保险机构发出投保的申请及缴纳保费，以完成保险购买。
						</p>
						<div class="title_level1">
							<div class="icon"></div>
							五、风险提示
						</div>
						<p>
							对使用平台而产生的风险甶用户自己承担，平台明确不提供任何明示或者默示的担保。您知晓并同意，您接受平台服务时可能面临如下风险和损失：
						</p>
						<p>
							1、监管风险：有关法律、法规及相关政策、规则发生变化，导致无法实现某保险产品的购买，您甶此可能遭受损失。
						</p>
						<p>
							2、违约风险：因保险机构无力或无意愿按保险合同履约，您由此可能遭受损失；
						</p>
						<p>
							3、成交风险：您所购买的保险产品无法承保，您由此无法获得保险保障及服务；
						</p>
						<p>
							4、过错风险：您的决策失误、操作不当、遗忘或泄露支付账户密码、密码被他人破解、您使用的计算机系统被第二方侵入、您委托他人代理交易时他人恶意或不当操作而造成的损失。
						</p>
						<p>
							5、本协议约定的有限责任及不可抗力因素导致的风险。
						</p>
						<div class="title_level1">
							<div class="icon"></div>
							六、免责条款
						</div>
						<p>
							1、本平台旨在为广大用户提供保险产品的信息，客户从本平台获取展示的保险产品信息的服务是无偿的；本平台不保证向用户提供的外部链接的准确性和完整性，该外部链接指向的不由本平台实际控制的任何网页上的内容，本平台对其合法性亦概不负责，亦不承担任何法律责任，本平台内所有内容亦不表明本平台之观点或意见。
						</p>
						<p>
							2、本平台中的文章（包括转贴文章）的版权仅归原作者所有，若作者有版权声明的或文章从其它网站转载而附带有原所有站的版权声明者，其版权归属以附带声明为准；文章仅代表作者本人的观点，与本平台立场无关。
						</p>
						<p>
							3、本平台所展示的产品信息由合作保险机构提供，内容的真实性、准确性和合法性甶提供合作保险机构负责，本平台对此不承担任何保证责任。
						</p>
						<p>
							4、平台仅提供合作保险机构产品线上信息服务，对任何个人用户与合作保险机构之间关于保险产品的销售、核保、承保、理赔、退保、投诉处理及客户服务等保险经营行为或其他的保险合同项下的争议，平台不承担责任。
						</p>
						<p>
							5、任何单位或个人认为本平台内容可能涉嫌侵犯其合法权益，应该及时向本平台书面反馈，并提供身份证明、权属证明及详细侵权情况证明，本平台在收到上述法律文件后，经过双方进一步沟通确认，将会尽快移除被控侵权内容。
						</p>
						<p>
							6、甶于用户将个人密码告知他人或与他人共享注册帐户，甶此导致的任何个人资料泄露，本平台不负任何责任。
						</p>
						<p>
							7、甶于与本平台链接的其它网站所造成之个人资料泄露及由此而导致的任何法律争议和后果，本平台不负任何责任。
						</p>
						<p>
							8、当政府司法机关依照法定程序要求本网站披露个人资料时，我们将根据执法单位之要求或为公共安全之目的提供个人资料。在此情况下之任何披露，本平台均得免责。
						</p>
						<p>
							9、用户不得在本平台操作违法事项，因违反本平台的用户服务协议及相关规定而触犯中华人民共和国法律的，一切后果自己负责，本平台不承担任何责任。
						</p>
						<p>
							10、凡以任何方式登陆本平台或直接、间接使用本平台网站资料者，视为自愿接受本平台声明的约束。
						</p>
						<p>
							11、本声明未涉及的问题参见国家有关法律法规，当本声明与国家法律法规冲突时，以国家法律法规为准。
						</p>
						<p class="tw_bold">
							12、因下列原因导致平台无法正常提供服务，骆驼规划免于承担责任：
						</p>
						<p class="tw_bold">
							1）系统停机维护或升级
						</p>
						<p class="tw_bold">
							2）因自然灾害、战争、恐怖袭击或罢工等不可抗力原因；
						</p>
						<p class="tw_bold">
							3）您的手机软硬件和通信线路、供电线路出现故障；
						</p>
						<p class="tw_bold">
							4）因您操作不当或通过非平台授权或认可的方式使用我们的服务；
						</p>
						<p class="tw_bold">
							5）因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、银行原因、第三方服务瑕疵或政府行为等原因；
						</p>
						<p class="tw_bold">
							尽管有前款约定，我们将采取合理行动积极促使服务恢复正常。
						</p>
						<div class="title_level1">
							<div class="icon"></div>
							七、协议变更、解除
						</div>
						<p>
							我们可以根据市场变化或经营的需要对本协议进行调整变更，协议变更调整后我们将通过www.luotuoguihua.com网站公告的方式提前予以公布，公告发布之日起第7个自然日后协议生效。
						</p>
						<p>
							若您无法同意变更修改后的协议内容，您有权停止使用相关服务或通过客服解除本协议；否则视为您同意并接受修改后的协议。
						</p>
						<div class="title_level1">
							<div class="icon"></div>
							八、知识产权的保护
						</div>
						<p>
							1、除非平台另行声明，骆驼规划以及关联公司的所有产品内容，包括但不限于著作、图片、档案、资料、网站架构、网站画面的安排、页面设计，均由我们或关联公司依法拥有知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。
						</p>
						<p>
							2、平台的Logo、“骆驼规划”等文字、图形及其组合，以及平台的其他标识、徵记、产品和服务名称均为平台及其关联公司在中国和其它国家的商标，未经平台书面授权，任何人不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、使用或作其他处理。
						</p>
						<div class="title_level1">
							<div class="icon"></div>
							九、法律适用与管辖
						</div>
						<p>
							本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生的争议，均依照中华人民共和国法律予以处理，并甶被告住所地人民法院管辖。
						</p>
					</div> -->
          <ServiceProtocol />
        </template>
        <template v-if="current === 33">
          <div class="description">
            <div class="title">
              润安国际保险经纪有限公司客户告知书
            </div>
            <div class="title_level1">
              尊敬的客户：
            </div>
            <p>
              感谢您委托我公司代为办理保险业务。本公司基于投保人的利益，为投保人与保险公司订立保险合同提供中介服务的保险专业中介机构。为了保护您的合法权益，按照《保险经纪人监管规定》的要求，本公司应履行客户告知义务，现将有关事项告知如下，请仔细阅读。
            </p>
            <p>一、公司基本情况</p>
            <p>(一）名称：润安国际保险经纪有限公司</p>
            <p>
              (二）住所：江西省南昌市东湖区阳明东路66号央央春天投资大厦12层03室
            </p>
            <p>
              (三）许可证名称及编号：经营保险经纪业务许可证编号260619000000800
            </p>
            <p>(四）许可证有效期：2018年10月11日至2024年9月28日</p>
            <p>
              (五）业务范围：在全国区域内（港、澳、台除外）为投保人拟定投保方案、选择保险人、办理投保手续；协助被保险人或受益人进行索赔；再保险经纪业务；为委托人提供防灾、防损或风险评估、风险管理咨询服务；中国银保监会批准的其他业务。
            </p>
            <p>(六） 经营区域：全国（港、澳、台除外）</p>
            <p>(七）联系方式：400-099-9559</p>
            <p>
              二、
              请仔细阅读保险条款，保险产品的广告、公告、彩页等宣传资料不属于保险合同的组成部分。请重点关注保险责任、责任免除或者除外责任、犹豫期后解除合同损失、投保人和被保险人权利义务、免赔额或免赔率的计算、等待期等内容，并可要求本公司服务人员对上述内容进行详细讲解。
            </p>
            <p>
              三、
              请向本公司服务人员了解《中华人民共和国保险法》等法律法规对于索赔时效、保险公司理赔时限、合同中止与失效、未成年人投保限额等的相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄或职业不真实等情形导致的法律
            </p>
            <p>
              四、
              根据《中华人民共和国保险法》的规定，保险经纪机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。
            </p>
            <p>
              五、 本公司已按《保险经纪人监管规定》投保职业责任保险。
            </p>
            <p>
              六、
              本公司为您与保险公司订立保险合同提供保经纪服务，并依据与保险公司签订的协议依法收取经纪费。
            </p>
            <p>
              七、
              本公司及公司高级管理人员与经纪业务相关的保险公司、其他中介机构不存在关联关系。
            </p>
            <p>
              八、
              如果您发现本公司服务人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证明或其他证据，可向本公司投诉（电话0791-86110959
              )。
            </p>

            <div class="last-name">
              润安国际保险经纪有限公司
            </div>
          </div>
        </template>
      </div>
    </div>
    <tools :type="qrCurrent" />
    <Footer :type="current" />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header";
import Pagaing from "@/components/pagaing2";
import Products from "@/service/products2";
import CompanyQualification from "@/components/information/CompanyQualification";
import OperatedPlatform from "@/components/information/OperatedPlatform";
// import CooperativeOrganization from '@/components/information/CooperativeOrganization'
import Branch from "@/components/information/Branch";
import PolicyInspection from "@/components/information/PolicyInspection";
import Empty from "@/components/information/Empty";
import ServiceProtocol from "@/components/information/ServiceProtocol";
import Contact from "@/components/information/Contact";
import Report from "@/components/information/Report";
import Footer from "@/components/Footer";
import Tools from "@/components/absoluteTools";
export default {
  metaInfo() {
    return {
      title: "骆驼规划官网-润安国际保险-专业保险规划机构，省心省钱买对保险",
      keywords: "骆驼规划,保险方案,保险评测,保险理赔",
      description:
        "骆驼规划是一家专业中立的第三方保险规划平台，致力于让普通家庭也能享受到量身定制的保险规划服务，提供包括重疾险、医疗险、儿童险、寿险、意外险等在内的保险方案定制、风险评测、理赔协助、保险科普、保险评测等服务。"
    };
  },
  // watchQuery: ['page'],
  // async asyncData ({ params, query, $axios, route, redirect }) {
  // 	let obj = {}
  // 	if (['31', '32', '33', '51', '52', '53', '54', '55', '65', '57', '58', '59'].indexOf(params.id) === -1) {
  // 		redirect('/404')
  // 	}
  // 	const pageIndex = query.page ? parseInt(query.page) : 1
  // 	obj.tableData = Products.slice(
  // 		(pageIndex - 1) * 7,
  // 		pageIndex * 7
  // 	);
  // 	obj.pageIndex = pageIndex,
  // 	obj.total = Products.length

  //    const { data: res } = await $axios.post(classes.pageInfo, {
  //      pageUrl: `https://www.luotuoguihua.com/information/${params.id || 31}`
  //    })
  //    if (res.result === 0) {
  //      obj.title = res.data.title
  //      obj.keywords = res.data.keyWords
  //      obj.description = res.data.description
  //    }
  //    obj.url = 'https://www.luotuoguihua.com' + route.path
  //    obj.path = route.path

  //    // 合作机构
  //    const { data: res1 } = await $axios.post('/api/insureadmin/insureChannelService/queryCooperationChannels', {})
  //    if (res1.result === 0) {
  //      obj.cooperList = res1.items.slice(
  //        (pageIndex - 1) * 7,
  //        pageIndex * 7
  //      )
  //      obj.total1 = res1.total
  //    }
  // 	return obj
  // },
  data() {
    return {
      pageType: 3,
      current: parseInt(this.$route.params.id || 31),
      qrCurrent: parseInt(
        ["31", "32", "33"].indexOf(this.$route.params.id) === -1
          ? "31"
          : this.$route.params.id
      ),
      tabs: [
        {
          name: "公司资质",
          id: 51
        },
        {
          name: "自营平台",
          id: 52
        },
        {
          name: "监管评价",
          id: 53
        },
        {
          name: "合作机构",
          id: 54
        },
        {
          name: "产品信息",
          id: 31
        },
        {
          name: "保单验真",
          id: 55
        },
        {
          name: "平台公告",
          id: 65
        },
        {
          name: "分支机构",
          id: 57
        },
        {
          name: "联系方式",
          id: 58
        },
        {
          name: "服务协议",
          id: 32
        },
        {
          name: "客户告知书",
          id: 33
        },
        {
          name: "公众举报",
          id: 59
        }
      ],
      pageIndex: 1,
      pageSize: 7,
      list: Products,
      list1: [],
      cooperList: [],
      url: "",
      path: "",
      title: "",
      keywords: "",
      description: "",
      total: Products.length,
      tableData: []
    };
  },
  name: "Information",
  components: {
    Header,
    Pagaing,
    Footer,
    Tools,
    CompanyQualification,
    OperatedPlatform,
    Empty,
    Branch,
    Contact,
    Report,
    PolicyInspection,
    ServiceProtocol
  },
  watch: {
    "$route.query.page"() {
      this.pageIndex = parseInt(this.$route.query.page || 1);
      this.tableData = this.list.slice(
        (this.pageIndex - 1) * this.pageSize,
        this.pageIndex * this.pageSize
      );
      this.cooperList = this.list1.slice(
        (this.pageIndex - 1) * this.pageSize,
        this.pageIndex * this.pageSize
      );
    }
  },
  mounted() {
    document.body.style.backgroundColor = "#F9FAFF";
    this.getCooperOrg();
    this.queryData();
  },
  methods: {
    queryData() {
      this.tableData = this.list.slice(
        (this.pageIndex - 1) * this.pageSize,
        this.pageIndex * this.pageSize
      );
    },
    getCooperOrg() {
      const res = {
        items: [
          {
            id: 114,
            title: "东方大地（武汉）保险经纪有限公司",
            shortTitle: "东方大地",
            startTime: "2021-06-01",
            endTime: "2024-05-31",
            cooperationScope: "健康险、年金险、寿险"
          },
          {
            id: 112,
            title: "中兴保险经纪有限公司",
            shortTitle: "中兴经纪",
            startTime: "2021-06-01",
            endTime: "2022-05-31",
            cooperationScope: "健康险"
          },
          {
            id: 110,
            title: "华贵人寿保险股份有限公司",
            shortTitle: "华贵人寿",
            startTime: "2021-12-31",
            endTime: "2022-12-30",
            cooperationScope: "健康险"
          },
          {
            id: 109,
            title: "乐橙保险代理有限公司",
            shortTitle: "乐橙云服",
            startTime: "2021-10-24",
            endTime: "2023-10-23",
            cooperationScope: "意外险、健康险、年金险、寿险"
          },
          {
            id: 107,
            title: "和谐健康保险股份有限公司",
            shortTitle: "和谐健康",
            startTime: "2021-04-24",
            endTime: "2023-04-23",
            cooperationScope: "健康险"
          },
          {
            id: 106,
            title: "众惠财产相互保险社",
            shortTitle: "众惠财产",
            startTime: "2022-03-09",
            endTime: "2023-03-08",
            cooperationScope: "健康险"
          },
          {
            id: 105,
            title: "瑞华健康保险股份有限公司",
            shortTitle: "瑞华健康",
            startTime: "2021-02-01",
            endTime: "2022-01-31",
            cooperationScope: "健康险"
          },
          {
            id: 103,
            title: "平安健康保险股份有限公司",
            shortTitle: "平安健康",
            startTime: "2021-12-22",
            endTime: "2022-12-21",
            cooperationScope: "健康险"
          },
          {
            id: 101,
            title: "中国人寿财产保险股份有限公司",
            shortTitle: "国寿财产",
            startTime: "2020-12-10",
            endTime: "2022-12-09",
            cooperationScope: "健康险"
          },
          {
            id: 99,
            title: "白鸽宝保险经纪有限公司",
            shortTitle: "白鸽宝",
            startTime: "2020-08-01",
            endTime: "2023-07-31",
            cooperationScope: "意外险、健康险"
          },
          {
            id: 14,
            title: "科成保险代理有限公司",
            shortTitle: "力码科技",
            startTime: "2021-10-27",
            endTime: "2022-10-27",
            cooperationScope: "意外险、健康险、年金险、寿险"
          },
          {
            id: 12,
            title: "华瑞保险销售有限公司",
            shortTitle: "华瑞云服",
            startTime: "2021-08-05",
            endTime: "2022-08-05",
            cooperationScope: "意外险、健康险、年金险、寿险"
          },
          {
            id: 11,
            title: "创信保险销售有限公司",
            shortTitle: "牛保",
            startTime: "2021-11-06",
            endTime: "2025-11-05",
            cooperationScope: "意外险、健康险、年金险、寿险"
          },
          {
            id: 10,
            title: "梧桐树保险经纪有限公司",
            shortTitle: "凤栖云服",
            startTime: "2021-04-01",
            endTime: "2023-03-31",
            cooperationScope: "意外险、健康险、年金险、寿险"
          },
          {
            id: 9,
            title: "网金保险销售服务有限公司",
            shortTitle: "易升云服",
            startTime: "2021-09-01",
            endTime: "2022-08-31",
            cooperationScope: "意外险、健康险、年金险、寿险"
          },
          {
            id: 8,
            title: "慧择保险经纪有限公司",
            shortTitle: "齐欣云服",
            startTime: "2020-03-21",
            endTime: "2023-03-20",
            cooperationScope: "意外险、健康险、年金险、寿险"
          },
          {
            id: 7,
            title: "保通保险代理有限公司",
            shortTitle: "i云服",
            startTime: "2023-02-02",
            endTime: "2023-02-24",
            cooperationScope: "意外险、健康险、年金险、寿险"
          }
        ],
        total: 17,
        result: 0,
        resultMessage: "响应成功"
      };
      if (res.result === 0) {
        this.list1 = res.items;
        this.cooperList = res.items.slice(
          (this.pageIndex - 1) * this.pageSize,
          this.pageIndex * this.pageSize
        );
        this.total1 = res.total;
      }
      // this.$ajax({
      //   url: "/api/insureadmin/insureChannelService/queryCooperationChannels",
      //   method: "POST"
      // }).then(res => {
      //   if (res.result === 0) {
      //     this.list1 = res.items;
      //     this.cooperList = res.items.slice(
      //       (this.pageIndex - 1) * this.pageSize,
      //       this.pageIndex * this.pageSize
      //     );
      //     this.total1 = res.total;
      //   }
      // });
    },
    onPageChange(index) {
      this.$router.push({
        path: `/information/31?page=${index}`
      });
    },
    onPageChange1(index) {
      this.$router.push({
        path: `/information/54?page=${index}`
      });
    },
    onChange(id) {
      this.current = id;
      this.$router.push({
        path: `/information/${id}`
      });
    }
  }
};
</script>
